'use client'

import { type PropsWithChildren, useEffect } from 'react'

import { setAcademyVisited } from '@common/utils/cookies'

import { useInitializeCurrentUser } from '@modules/user/hooks'
import { useLayoutStore } from '@stores/layout/layout.store'

export function AcademyInitialization({ children }: PropsWithChildren) {
  const { stopLoader } = useLayoutStore()

  useInitializeCurrentUser()

  useEffect(() => {
    stopLoader()
  }, [stopLoader])

  useEffect(() => {
    setAcademyVisited()
  }, [])

  return <>{children}</>
}
